import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime-corejs2/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/createClass";
import _inherits from "@babel/runtime-corejs2/helpers/inherits";
import _createSuper from "@babel/runtime-corejs2/helpers/createSuper";
import _typeof from "@babel/runtime-corejs2/helpers/typeof";
var _excluded = ["type", "name", "legend", "children", "defaultValue", "value", "disabled", "onChange", "handleChange"];
import * as React from 'react';
import clsx from 'clsx';
import shallowequal from 'shallowequal';
import { Base } from '../../Base';
var styles = {
  "root": "ToggleGroup-root_MqYEk",
  "pill": "ToggleGroup-pill_2ytf9"
};
var ensureArray = function ensureArray(value) {
  if (Array.isArray(value)) {
    return value;
  }
  if (/string|number/.test(_typeof(value))) {
    return [value];
  }
  return [];
};
var noop = function noop() {};
var ToggleGroup = /*#__PURE__*/function (_React$Component) {
  _inherits(ToggleGroup, _React$Component);
  var _super = _createSuper(ToggleGroup);
  function ToggleGroup() {
    var _this;
    _classCallCheck(this, ToggleGroup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      values: ensureArray(_this.props.value || _this.props.defaultValue)
    };
    _this.renderToggle = function (child) {
      var _this$props = _this.props,
        type = _this$props.type,
        name = _this$props.name,
        disabled = _this$props.disabled;
      return /*#__PURE__*/React.cloneElement(child, {
        type: type,
        disabled: disabled,
        tagName: 'label',
        name: child.props.name || name,
        checked: _this.isChecked(child.props.value),
        className: clsx(child.props.className, styles.pill),
        onChange: function onChange() {
          return _this.handleChange(child.props.value);
        }
      });
    };
    return _this;
  }
  _createClass(ToggleGroup, [{
    key: "componentDidUpdate",
    value:
    /**
     * Allow controlling the component from a parent.
     */
    function componentDidUpdate(prevProps) {
      if (this.props.value === prevProps.value) {
        return;
      }
      var arrayValue = ensureArray(this.props.value);
      if (shallowequal(this.state.values, arrayValue)) {
        return;
      }

      // eslint-disable-next-line react/no-did-update-set-state
      this.setState({
        values: arrayValue
      });
    }
  }, {
    key: "isChecked",
    value: function isChecked(value) {
      return this.state.values.indexOf(value) >= 0;
    }
  }, {
    key: "handleChange",
    value: function handleChange(value) {
      var _this2 = this;
      var checked = this.isChecked(value);
      var callback = function callback() {
        if (_this2.props.handleChange) {
          _this2.props.handleChange(_this2.state.values);
        }
      };
      if (this.props.value === undefined) {
        if (this.props.type === 'radio') {
          this.setState({
            values: ensureArray(value)
          }, !checked ? callback : noop);
          return;
        }
        this.setState(function (prevState) {
          return {
            values: checked ? prevState.values.filter(function (val) {
              return val !== value;
            }) : [].concat(_toConsumableArray(prevState.values), [value])
          };
        }, callback);
      }
    }
  }, {
    key: "renderToggles",
    value: function renderToggles() {
      // Ensure null children filtering by converting to a true Array.
      // eslint-disable-next-line no-undef
      // $FlowFixMe[underconstrained-implicit-instantiation]
      return React.Children.toArray(this.props.children).map(this.renderToggle);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
        type = _this$props2.type,
        name = _this$props2.name,
        legend = _this$props2.legend,
        children = _this$props2.children,
        defaultValue = _this$props2.defaultValue,
        value = _this$props2.value,
        disabled = _this$props2.disabled,
        onChange = _this$props2.onChange,
        handleChange = _this$props2.handleChange,
        extraProps = _objectWithoutProperties(_this$props2, _excluded);
      return (
        /*#__PURE__*/
        // $FlowFixMe[cannot-spread-inexact]
        React.createElement(Base, _extends({
          tagName: "fieldset",
          onChange: onChange,
          className: styles.root
        }, extraProps), legend && /*#__PURE__*/React.createElement("legend", null, legend), this.renderToggles())
      );
    }
  }]);
  return ToggleGroup;
}(React.Component);
ToggleGroup.defaultProps = {
  type: 'radio'
};
export default ToggleGroup;